import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceWithoutPaymentComponent } from './invoice-without-payment.component';
import { PosTableModule } from '../pos-table/pos-table.module';



@NgModule({
  declarations: [InvoiceWithoutPaymentComponent],
  imports: [
    CommonModule,
    PosTableModule
  ],
  exports: [InvoiceWithoutPaymentComponent]
})
export class InvoiceWithoutPaymentModule { }
